import { createFileRoute } from '@tanstack/react-router';
import Rewards from 'src/pages/Organization/Event/Mods/Rewards';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/$modId/rewards',
)({
  component: Rewards,
});
